import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  useLocation,
} from "react-router-dom";
import Preloader from "../src/components/Pre";
import Navbar from "./components/Navbar";
import Home from "./components/Home/Home";
import About from "./components/About/About";
import Projects from "./components/Projects/Projects";
import Footer from "./components/Footer";
import Resume from "./components/Resume/ResumeNew";
import ScrollToTop from "./components/ScrollToTop";
import NFTMarketplace from "./components/NFTMarketplace/NFTMarketplace";
import "./style.css";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";

function OfflinePage() {
  return (
    <div
      style={{
        minHeight: "100vh",
        width: "100vw",
        background: "linear-gradient(135deg, #1b1a2e 0%, #3a006f 100%)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        color: "#c770f0",
        fontFamily: "inherit",
        textAlign: "center",
      }}
    >
      <h2 style={{ color: "#c770f0", marginBottom: 24 }}>You are offline</h2>
      <p style={{ color: "#fff", marginBottom: 0 }}>
        Please check your internet connection.
      </p>
    </div>
  );
}

function App() {
  const [load, updateLoad] = useState(true);
  const [isOnline, setIsOnline] = useState(window.navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);
    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);
    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  // Preloader Effect
  useEffect(() => {
    const timer = setTimeout(() => {
      updateLoad(false);
    }, 1200);
    return () => clearTimeout(timer);
  }, []);

  if (!isOnline) {
    return <OfflinePage />;
  }

  return (
    <Router basename="/">
      <TrackPageViews /> {/* Track page views on route change */}
      <Preloader load={load} />
      <div className="App" id={load ? "no-scroll" : "scroll"}>
        <Navbar />
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/project" element={<Projects />} />
          <Route path="/about" element={<About />} />
          <Route path="/resume" element={<Resume />} />
          <Route path="/nft-marketplace" element={<NFTMarketplace />} />{" "}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

// ✅ Track Google Analytics Page Views
function TrackPageViews() {
  const location = useLocation();

  useEffect(() => {
    if (window.gtag) {
      window.gtag("config", "G-DFC0JK76FL", {
        page_path: location.pathname,
      });
    }
  }, [location]);

  return null; // This component doesn't render anything
}

export default App;
